var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2307692,75 C79.1796,73.355 80.3483077,73.422 83.3335385,70.481 C86.3208,67.54 88.7364,64.039 90.4067077,60.15 C92.0770154,56.262 93,51.987 93,47.5 C93,43.013 92.0770154,38.738 90.4067077,34.85 C88.7364,30.961 86.3208,27.46 83.3335385,24.519 C80.3483077,21.578 76.7934462,19.198 72.8446154,17.555 C68.8968,15.909 64.5560308,15 60,15 C55.4439692,15 51.1032,15.909 47.1553846,17.555 C43.2065538,19.198 39.6516923,21.578 36.6664615,24.519 C33.6792,27.46 31.2636,30.961 29.5932923,34.85 C27.9229846,38.738 27,43.013 27,47.5 C27,51.987 27.9229846,56.262 29.5932923,60.15 C31.2636,64.039 33.6792,67.54 36.6664615,70.481 C39.6516923,73.422 40.8204,73.355 44.7692308,75 L44.7692308,95 L54.9230769,105 L65.0769231,105 L75.2307692,95 L75.2307692,75 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    x2: 75,
    y1: 90,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    x2: 60,
    y1: 55,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 65,
    y1: 50,
    y2: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.5709ebae727bb7a2a4288276c00a47e4.svg";
export { ForwardRef as ReactComponent };